// Ambient Background Component with floating bubbles
const AmbientBackground = () => (
    <div className="ambient-bg">
        <div className="bubble bubble-1"></div>
        <div className="bubble bubble-2"></div>
        <div className="bubble bubble-3"></div>
    </div>
);

export default AmbientBackground;
